import type { RouteLocationNormalizedLoaded } from 'vue-router'

export interface BreadcrumbItem {
  label: string
  to?: string
}

export type BreadcrumbResolver = (route: RouteLocationNormalizedLoaded) => BreadcrumbItem[]
export type BreadcrumbMeta = BreadcrumbItem[] | BreadcrumbResolver

export function resolveBreadcrumbs(route: RouteLocationNormalizedLoaded): BreadcrumbItem[] {
  const meta = route.meta.breadcrumbs as BreadcrumbMeta | undefined

  if (!meta) {
    if (typeof route.meta.title === 'string' && route.meta.title) {
      return [{ label: route.meta.title }]
    }

    if (typeof route.name === 'string' && route.name) {
      return [{ label: route.name }]
    }

    return []
  }

  return typeof meta === 'function' ? meta(route) : meta
}
